import React, { Component } from 'react';
import { Checkbox } from '@thd-olt-component-react/checkbox';
import PropTypes from 'prop-types';
import './histogram.style.scss';
import classNames from 'classnames';


export class Histogram extends Component {

  getPercentageRating = (totalReviews, countOfStarReviews) => {
    return (parseInt(countOfStarReviews, 10) / parseInt(totalReviews, 10)) * 100;
  };

  histogramBarClick = (ratingValue, count) => {
    const { clickableFilters, onClick, onFilterChange } = this.props;
    if (clickableFilters && count > 0) {
      onFilterChange(ratingValue);
      if (onClick) {
        onClick(ratingValue);
      }
    }
  };

  renderHistogram = (totalReviews, ratingBars) => {
    const {
      clickableFilters,
      filterCheckboxes,
      percentage,
      selectedSentiment,
    } = this.props;

    const countClickable = classNames(
      'reviews-histogram__bar-count', {
        'reviews-histogram__bar-count-clickable': clickableFilters
      }
    );

    const buttonWrapper = classNames(
      'reviews-histogram__bar-graph', {
        pointer: clickableFilters
      }
    );

    const barWrapper = classNames(
      'reviews-histogram__bar-wrapper', {
        'reviews-histogram__bar-wrapper--underline': clickableFilters
      }
    );

    return (ratingBars || []).map((histogram, index) => (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div
        key={histogram.ratingValue}
        className={barWrapper}
        onClick={() => {
          this.histogramBarClick(parseInt(histogram.ratingValue, 10), histogram.count);
        }}
      >
        <span className="reviews-histogram__bar-rating">{histogram.ratingValue}</span>
        <img
          className="reviews-histogram__bar-stars"
          alt="star-icon"
          src="https://assets.homedepot-static.com/images/v1/star-symbol--orange.svg"
        />
        <button
          className={buttonWrapper}
          type="button"
        >
          <span
            className="reviews-histogram__bar-graph--percent"
            style={{ width: `${this.getPercentageRating(totalReviews, histogram.count)}%` }}
          />
        </button>
        <span className={countClickable}>
          {percentage
            ? `${parseInt(this.getPercentageRating(totalReviews, histogram.count), 10)}%`
            : `${histogram.count}`}
        </span>
      </div>
    ));
  };

  render() {
    const {
      filterCheckboxes,
      ratings,
      totalReviews,
    } = this.props;
    const sortedRatings = ratings ? ratings.sort((i, n) => {
      return n.ratingValue - i.ratingValue;
    }) : [];
    return (
      <div className="reviews-histogram">
        {this.renderHistogram(totalReviews, sortedRatings, filterCheckboxes)}
      </div>
    );
  }
}

Histogram.propTypes = {
  clickableFilters: PropTypes.bool,
  filterCheckboxes: PropTypes.arrayOf(PropTypes.shape({
    checked: PropTypes.bool,
    id: PropTypes.string,
    value: PropTypes.string,
  })),
  /** Function when bar is clicked */
  onClick: PropTypes.func,
  onFilterChange: PropTypes.func,
  /** display percentage value instead of count */
  percentage: PropTypes.bool,
  /** Histogram bar label and number of star ratings to calculate % */
  ratings: PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.number,
    ratingValue: PropTypes.number,
  })),
  selectedSentiment: PropTypes.instanceOf(Object),
  /** Number of total reviews */
  totalReviews: PropTypes.number.isRequired,
};

Histogram.defaultProps = {
  clickableFilters: false,
  filterCheckboxes: null,
  onClick: null,
  onFilterChange: null,
  percentage: false,
  ratings: null,
  selectedSentiment: null,
};
